module.exports = __webpack_public_path__ + "static/media/05_snapshot_page.1710e425.png";